// doctor-frontend/src/utils/tenantUrl.js
// Tenant helpers (path-mode: /t/:slug/*, and works fine in subdomain mode too)

export function getTenantSlug() {
  try {
    const pathname = window.location.pathname || '';
    const m = pathname.match(/^\/t\/([^/]+)/);
    if (m) return decodeURIComponent(m[1]);

    // Safe fallback (does not change behavior if you don't store these)
    const ls =
      window.localStorage?.getItem('tenantSlug') ||
      window.localStorage?.getItem('activeTenantSlug') ||
      window.localStorage?.getItem('selectedTenantSlug');

    return ls ? String(ls).trim() : null;
  } catch {
    return null;
  }
}

export function tenantUrl(path) {
  const slug = getTenantSlug();
  const p = String(path || '');

  // If no slug, keep exactly the old behavior
  if (!slug) return p;

  // If already tenant-prefixed, return as-is
  if (p.startsWith(`/t/${slug}`)) return p;

  // Handle absolute URLs safely (only for API endpoints)
  // Example: tenantUrl("http://localhost:5000/api/tenants/public")
  // => "http://localhost:5000/t/aiimsjodhpur-cmfm/api/tenants/public"
  if (/^https?:\/\//i.test(p)) {
    try {
      const u = new URL(p);

      // ✅ NO-REGRESSION FIX:
      // treat /api as well as /api/ as API roots
      const isApi =
        u.pathname === '/api' || u.pathname.startsWith('/api/');

      // Only tenant-prefix API calls to avoid breaking external URLs/assets
      if (isApi && !u.pathname.startsWith(`/t/${slug}/`)) {
        // If it's already /t/<something>/..., don't double-prefix
        if (!u.pathname.startsWith('/t/')) {
          u.pathname = `/t/${slug}${u.pathname}`.replace(/\/{2,}/g, '/');
        }
      }
      return u.toString();
    } catch {
      // If parsing fails, fall back to old behavior
      return p;
    }
  }

  // Existing relative-path behavior (preserved)
  if (!p.startsWith('/')) return `/t/${slug}/${p}`.replace(/\/{2,}/g, '/');
  return `/t/${slug}${p}`.replace(/\/{2,}/g, '/');
}
